// Vuex Authorization module actions
import API from '../../config/api';

import { FILL_LOGIN_TOKEN, FILL_USER_SESSION } from './mutations-types';

export default {
  async loginToPlatform(_ctx, params) {
    try {
      await API.post('/authorization/loginToPlatform', params);
      return true;
    } catch (err) {
      return false;
    }
  },
  async checkLoginParams({ commit }, params) {
    try {
      const result = (await API.post('/authorization/checkLoginParams', params)).data.data;
      commit(FILL_LOGIN_TOKEN, result);
      localStorage.removeItem('blockadeExpiredAt');
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async checkIfUserSessionExists({ commit }) {
    try {
      const result = (await API.get('/authorization/checkIfUserSessionExists')).data.data;
      commit(FILL_USER_SESSION, result);
    } catch (err) {
      console.log(err);
    }
  },
  async logoutFromPlatform() {
    try {
      await API.delete('/authorization/logoutFromPlatform');
    } catch (err) {
      console.log(err);
    }
  },
};
